var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9192 14.333C11.6092 14.333 12.1692 14.893 12.1692 15.583C12.1692 16.2731 11.6092 16.8331 10.9192 16.8331C10.2292 16.8331 9.66918 16.2731 9.66918 15.583C9.66918 14.893 10.2292 14.333 10.9192 14.333ZM11.7525 12.6662C11.7525 12.1987 12.0925 11.6453 12.5258 11.4061C13.7758 10.7177 14.4483 9.3035 14.2 7.88675C13.9642 6.54251 12.8608 5.43828 11.5158 5.20243C10.5308 5.03242 9.53252 5.29577 8.77502 5.9308C8.01919 6.56667 7.58502 7.49673 7.58502 8.48345C7.58502 8.94431 7.95835 9.31683 8.41835 9.31683C8.87835 9.31683 9.25168 8.94431 9.25168 8.48345C9.25168 7.99009 9.46835 7.52506 9.84668 7.20671C10.2308 6.88503 10.7233 6.75502 11.2275 6.84419C11.8833 6.9592 12.4425 7.51923 12.5575 8.17427C12.685 8.90014 12.3567 9.59518 11.7208 9.9452C10.7575 10.4761 10.085 11.5945 10.085 12.6654C10.085 13.1262 10.4583 13.4987 10.9183 13.4987C11.3783 13.4987 11.7517 13.1262 11.7517 12.6654L11.7525 12.6662ZM20.9992 16.8331V11.2828C20.9992 5.8833 16.9125 1.37721 11.6958 1.02219C8.80002 0.830513 5.96669 1.88724 3.92336 3.93319C1.88003 5.97997 0.823363 8.8143 1.0242 11.7111C1.39086 17.0064 6.06752 21 11.9025 21H16.8333C19.1308 21 20.9992 19.1307 20.9992 16.8331ZM11.5833 2.68562C15.9292 2.98064 19.3325 6.75669 19.3325 11.2819V16.8323C19.3325 18.2107 18.2108 19.3324 16.8325 19.3324H11.9017C6.87252 19.3324 2.99669 16.0789 2.68586 11.5953C2.51836 9.17932 3.39836 6.81586 5.10169 5.11076C6.67002 3.53983 8.79752 2.66562 11.0117 2.66562C11.2017 2.66562 11.3925 2.67229 11.5825 2.68479L11.5833 2.68562Z",
    fill: "url(#paint0_linear_6573_1853)",
    stroke: "url(#paint1_linear_6573_1853)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6573_1853",
    x1: 5.96266,
    y1: 2.20038,
    x2: 15.843,
    y2: 19.3137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6573_1853",
    x1: 5.96266,
    y1: 2.20038,
    x2: 15.843,
    y2: 19.3137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/Faq.8de0dd01c25f2e66cc0d2464cb772e4d.svg";
export { ForwardRef as ReactComponent };